module.exports = __webpack_public_path__ + "img/weather.f426302f.svg";